/* N8KD P1 mobile conversion improvements.
   Additive, DOM-level only — no product content is edited in Shopify Admin.
   Both actions below are guarded to no-op if the expected structure isn't
   found, so a future product-description edit can't break the page. */
(function () {
  function reorderDescription() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.n8kdReordered) return;
    var children = Array.prototype.slice.call(desc.children);
    var ulIndex = children.findIndex(function (c) { return c.tagName === 'UL'; });
    if (ulIndex < 1) return;
    var bulletsHeading = children[ulIndex - 1];
    var bulletsList = children[ulIndex];
    if (bulletsHeading.tagName !== 'P' || !bulletsHeading.textContent.trim()) return;
    if (desc.firstElementChild === bulletsHeading) return;
    desc.insertBefore(bulletsList, desc.firstElementChild);
    desc.insertBefore(bulletsHeading, bulletsList);
    desc.dataset.n8kdReordered = 'true';
  }

  function addQuickNav() {
    if (document.querySelector('.n8kd-quick-nav')) return;
    var drawerNav = document.querySelector('.menu-drawer__navigation');
    if (!drawerNav) return;
    var nav = document.createElement('nav');
    nav.className = 'n8kd-quick-nav';
    nav.setAttribute('aria-label', 'Quick product links');
    nav.innerHTML =
      '<a href="/products/lash-vitality-mascara">Mascara</a>' +
      '<a href="/products/lash-enhancing-serum">Serum</a>' +
      '<a href="/products/n8kd-mascara-lash-serum-bundle-peptide-lash-duo">Bundles</a>' +
      '<a href="/products/n8kd-precision-brow-pencil-brown">Brow</a>' +
      '<a href="/products/n8kd-infinite-gel-eyeliner-black">Eyeliner</a>';
    drawerNav.insertBefore(nav, drawerNav.firstChild);
  }

  function run() {
    reorderDescription();
    addQuickNav();
  }

  document.addEventListener('DOMContentLoaded', run);
  if (document.readyState !== 'loading') run();
})();
